<div class="row">
  <div class="col">
    <header appHeaderShadow class="bg-brand-header fixed-top">
      <div class="container-fluid height-inherit">
        <div class="row height-inherit">
          <div class="col height-inherit">
            <nav class="navbar navbar-expand-lg navbar-light height-inherit">
              <button
                (click)="toggleNavBar()"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler p-0"
                data-target="#navbarSupportedContent"
                data-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="d-flex">
                <a
                  *ngIf="!!(logoUrl$ | async)"
                  [href]="logoAnchorUrl$ | async"
                  aria-hidden="true"
                  class="navbar-brand mr-0 no-logo"
                  ><img
                    [attr.height]="logoHeight$ | async"
                    [attr.width]="logoWidth$ | async"
                    [src]="logoUrl$ | async"
                    alt=""
                    class="header-logo"
                /></a>
                <a [href]="logoAnchorUrl$ | async" class="navbar-brand mr-0"> </a>
                <a
                  [innerHTML]="siteName$ | async"
                  [style]="siteNameStyle$ | async"
                  class="navbar-brand no-logo"
                  routerLink="/home"
                >
                </a>
              </div>

              <div [ngbCollapse]="isNavBarCollapsed" class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto">
                  <li class="nav-item divider-vertical d-none d-lg-block"></li>

                  <li class="nav-item dropdown">
                    <a
                      class="nav-link dropdown-toggle"
                      href=""
                      (click)="(false)"
                      id="myProductsLinksMenu"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      >My Products</a
                    >
                    <div class="dropdown-menu" aria-labelledby="myProductsLinksMenu">
                      <a class="dropdown-item" href="/products" *appIfFeature="'!data_entitlement_v2'"
                        >My Data Products</a
                      >
                      <a class="dropdown-item" href="/data" *appIfFeature="'data_entitlement_v2'">My Data Products</a>
                      <a class="dropdown-item" href="/software">My Software Products</a>
                    </div>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/samples">Sample Datasets</a>
                  </li>
                  <li class="nav-item dropdown">
                    <a
                      (click)="(false)"
                      aria-expanded="false"
                      aria-haspopup="true"
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      id="navbarDropdownMenuLink"
                      role="button"
                      >Visualize</a
                    >
                    <div aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu">
                      <a class="dropdown-item" href="/visualization/map-explorer">Map Explorer</a>
                      <a class="dropdown-item" href="/usecases/property-risk" *appIfFeature="'!hide_demo_sites'"
                        >Property Risk Profile Demo</a
                      >
                      <a
                        class="dropdown-item"
                        href="/usecases/home-search-real-estate"
                        *appIfFeature="'!hide_demo_sites'"
                        >Home Search Real Estate Demo</a
                      >
                    </div>
                  </li>
                </ul>

                <ul class="navbar-nav navbar-right">
                  <!--Search Icon-->
                  <li class="nav-item">
                    <button aria-label="Search" class="btn d-sm-block btn-icon-only text-white" routerLink="/search">
                      <i aria-hidden="true" class="pbi-icon-outline pbi-search d-lg-inline" id="searchHeader"></i>
                    </button>
                  </li>
                  <!--Applications Menu-->
                  <li class="nav-item dropdown">
                    <button
                      class="btn btn-icon-only dropdown-toggle text-white"
                      data-bs-toggle="dropdown"
                      aria-labelledby="app-offscreen"
                      aria-haspopup="true"
                      aria-expanded="false"
                      id="community"
                    >
                      <i class="pbi-icon-outline pbi-apps d-none d-lg-inline" aria-hidden="true"></i>

                      <span class="d-lg-none" id="app-offscreen">
                        <i class="pbi-icon-mini pbi-grid-4" aria-hidden="true"></i>&nbsp;Applications
                      </span>
                    </button>
                    <div class="dropdown-menu" role="menu" aria-labelledby="community">
                      <div class="section-head hidden-xs">Your Apps</div>
                      <a class="dropdown-item" href="https://customer.precisely.com/" target="_blank"
                        >Customer Community</a
                      >
                      <a class="dropdown-item" href="https://partner.precisely.com/" target="_blank"
                        >Partner Community</a
                      >
                    </div>
                  </li>

                  <!-- Support menu -->
                  <li class="nav-item dropdown menu-help">
                    <button
                      aria-expanded="false"
                      aria-haspopup="true"
                      aria-labelledby="help-offscreen"
                      class="btn dropdown-toggle btn-icon-only text-white"
                      data-bs-toggle="dropdown"
                      id="help"
                    >
                      <i aria-hidden="true" class="pbi-icon-outline pbi-help-circle d-none d-lg-inline"></i>

                      <span class="d-lg-none" id="help-offscreen">
                        <i aria-hidden="true" class="pbi-icon-mini pbi-help-circle"></i>&nbsp;Support
                      </span>
                    </button>
                    <app-help-menu class="dropdown-menu" aria-labelledby="help"></app-help-menu>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/login">Sign In</a>
                  </li>
                  <ng-container *appIfFeature="'!hide_signup_link'">
                    <li class="nav-item" *ngIf="!(isMasterCardUser$ | async)">
                      <a class="nav-link" (click)="navigateToSignUp()" style="cursor: pointer">Sign Up</a>
                    </li>
                  </ng-container>
                  <li *appIfFeature="'start_free_trial_link'">
                    <button
                      pButton
                      type="button"
                      class="btn btn-link btn-help"
                      label="Start Free Trial"
                      (click)="onClick()"
                    ></button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>
